import { render } from "./GerarNovoPedidoInicio.vue?vue&type=template&id=48fcc9d9&scoped=true"
import script from "./GerarNovoPedidoInicio.vue?vue&type=script&lang=js"
export * from "./GerarNovoPedidoInicio.vue?vue&type=script&lang=js"

import "./GerarNovoPedidoInicio.vue?vue&type=style&index=0&id=48fcc9d9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fcc9d9"]])

export default __exports__